import { Link } from 'react-router-dom';


export default function Pricing() {
  // Define packages with IDs that match the ones in the pricing page
  const packages = [
    {
      id: 'basic',
      name: 'Standard Portrait',
      price: '25',
      features: [
        'Single person portrait',
        'Basic conversation abilities',
        'Free software updates'
      ]
    },
    {
      id: 'premium',
      name: 'Family Portrait',
      price: '35',
      isPopular: true,
      features: [
        'Up to 2 family members',
        'Advanced conversation abilities',
        'Premium frame designs',
      ]
    },
    {
      id: 'ultimate',
      name: "Headmaster's Portrait",
      price: '67',
      features: [
        'Multiple portraits (up to 6)',
        'Premium AI capabilities',
        'Priority customer support',
      ]
    }
  ];

  return (
    <section id="pricing" className="pricing">
      <h2 className="section-title">Choose Your Enchantment</h2>
      
      <div className="pricing-container">
        {packages.map((pkg) => (
          <div key={pkg.id} className="pricing-card">
            {pkg.isPopular && <div className="popular-tag">Popular</div>}
            <h3 className="pricing-title">{pkg.name}</h3>
            <div className="price">${pkg.price}</div>
            <span style={{fontSize: '0.7rem'}}>per month, billed annually</span>
            <ul className="feature-list">
              {pkg.features.map((feature, index) => (
                <li key={index} className="feature-item">{feature}</li>
              ))}
            </ul>
            <Link 
              to={`/pricing?preselect=${pkg.id}`} 
              className="cta-button"
            >
              SELECT PACKAGE
            </Link>
          </div>
        ))}
      </div>

      <style jsx>{`
        .pricing {
          background: radial-gradient(circle at 50% 50%, rgba(183, 145, 221, 0.47) 0%, rgb(0, 0, 0) 60%);
          color: #16161D;
          padding: 8rem 2rem;
          text-align: center;
        }
        
        .section-title {
          font-family: serif;
          font-size: 2.5rem;
          text-align: center;
          margin-bottom: 3rem;
          position: relative;
          display: inline-block;
          font-weight: 600;
          color:rgb(255, 255, 255);
        }
        
        .section-title::after {
          content: '';
          position: absolute;
          width: 80px;
          height: 4px;
          background: #F9B932;
          bottom: -15px;
          left: 50%;
          transform: translateX(-50%);
        }
        
        .pricing-container {
          max-width: 1200px;
          margin: 4rem auto 0;
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          gap: 2rem;
          cursor: pointer;
        }
        
        .pricing-card {
          background: white;
          border-radius: 15px;
          padding: 3rem 2rem;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
          position: relative;
          overflow: hidden;
          transition:  all 0.5s cubic-bezier(0.25, 0.1, 0.25, 1);
          z-index: 1;
        }
        
        .pricing-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 0;
          background: linear-gradient(135deg, #372162 0%, #6A3AB2 100%);
          z-index: -1;
          transition:  all 0.5s cubic-bezier(0.25, 0.1, 0.25, 1);
        }
        
        .pricing-card:hover {
          transform: translateY(-10px);
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
          color: #F0F0F6;
        }
        
        .pricing-card:hover::before {
          height: 100%;
        }
        
        .pricing-card:hover .price {
          color: #F9B932;
        }
        
        .pricing-card:hover .feature-item {
          border-color: rgba(255, 255, 255, 0.1);
        }
        
        .popular-tag {
          position: absolute;
          top: 20px;
          right: -30px;
          background: #F9B932;
          color: #16161D;
          padding: 0.5rem 3rem;
          font-size: 0.8rem;
          font-weight: 600;
          transform: rotate(45deg);
        }
        
        .pricing-title {
          font-size: 1.8rem;
          margin-bottom: 1.5rem;
          font-family: serif;
        }
        
        .price {
          font-size: 3.5rem;
          font-weight: 700;
          color: #372162;
          transition:  all 0.5s cubic-bezier(0.25, 0.1, 0.25, 1);
        }
        
        .price span {
          font-size: 1rem;
          opacity: 0.7;
          font-weight: 400;
        }
        
        .feature-list {
          margin-bottom: 2rem;
          list-style: none;
          padding: 0;
        }
        
        .feature-item {
          padding: 1rem 0;
          border-bottom: 1px solid rgba(0, 0, 0, 0.1);
          transition: all 0.5s cubic-bezier(0.25, 0.1, 0.25, 1);
        }
        
        .feature-item:last-child {
          border-bottom: none;
        }
        
        .cta-button {
          background: #F9B932;
          color: #16161D;
          font-size: 1rem;
          font-weight: 600;
          padding: 0.8rem 1.8rem;
          border-radius: 50px;
          border: none;
          cursor: pointer;
          transition:  all 0.5s cubic-bezier(0.25, 0.1, 0.25, 1);
          text-transform: uppercase;
          letter-spacing: 1px;
          text-decoration: none;
          display: inline-block;
        }
        
        .cta-button:hover {
          transform: translateY(-3px);
          box-shadow: 0 10px 20px rgba(249, 185, 50, 0.3);
        }
        
        @media (max-width: 768px) {
          .pricing-container {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </section>
  );
} 